import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Results" className="border-y border-grape/10 bg-white/70" data-id="element-254" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-255" data-mp="2wvdy03fpag7h">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-256" data-mp="2nx1wv7h7k00s">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-257" data-mp="2nz4y6nnt9fkt">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-258" data-mp="297327eov36q2">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-259" data-mp="2dzw6y2kbyf25">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}